var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThreejs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    strokeLinecap: "square",
    strokeMiterlimit: 10,
    viewBox: "0 0 226.77 226.77",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(8.964 4.2527)",
    fillRule: "evenodd",
    stroke: "#000",
    strokeLinecap: "butt",
    strokeLinejoin: "round",
    strokeWidth: 4
  }, /*#__PURE__*/React.createElement("path", {
    d: "m63.02 200.61-43.213-174.94 173.23 49.874z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m106.39 50.612 21.591 87.496-86.567-24.945z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.91 125.03-10.724-43.465 43.008 12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.458 38.153 10.724 43.465-43.008-12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m149.47 62.93 10.724 43.465-43.008-12.346z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m84.915 125.06 10.724 43.465-43.008-12.346z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreejs);
export default __webpack_public_path__ + "static/media/threejs.a02bc572667de670fbfb2173c0331d05.svg";
export { ForwardRef as ReactComponent };